import Loader from '@/shared-components/loader/Loader'; 
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';

import './styles/SettingsLoadingPage.css';

export default function SettingsLoadingPage({ page = "" }) {
  return (
    <div className="settings-loading-page__container">
      <SettingsHeading text={page} />
      <Loader inline className="settings-loading-page__spinner" thin />
    </div>
  );
}
